let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1q7nt")).then(() => parcelRequire('8mRWC'));